import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, RotateCcw, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function TutorialEngine({ steps = [], onExit, renderStep, onRestart, onBack, showStepNavigation = true }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!Array.isArray(steps) || steps.length === 0) {
    return null;
  }

  const currentStep = steps[currentIndex];
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === steps.length - 1;

  const goNext = () => {
    setCurrentIndex((index) => Math.min(index + 1, steps.length - 1));
  };

  const goPrev = () => {
    setCurrentIndex((index) => Math.max(index - 1, 0));
  };

  const goBack = () => {
    const targetIndex = Math.max(currentIndex - 1, 0);

    if (typeof onBack === 'function') {
      onBack(steps[targetIndex], targetIndex);
    }

    setCurrentIndex(targetIndex);
  };

  const restart = () => {
    setCurrentIndex(0);
    if (typeof onRestart === 'function') {
      onRestart();
    }
  };

  const handleExit = () => {
    if (typeof onExit === 'function') {
      onExit();
    }
  };

  const stepContent =
    typeof renderStep === 'function'
      ? renderStep(currentStep, currentIndex, { goNext, goPrev, restart, exit: handleExit })
      : (
          <div className="space-y-2">
            {currentStep?.title ? (
              <h3 className="text-base font-semibold">{currentStep.title}</h3>
            ) : null}
            {currentStep?.text ? (
              <p className="text-sm text-muted-foreground">{currentStep.text}</p>
            ) : null}
          </div>
        );

  return (
    <div className="flex flex-col gap-4">
      {stepContent}

      <div className="flex flex-wrap items-center justify-between gap-2 border-t border-border pt-4">
        {typeof onBack === 'function' && (
          <Button
            variant="outline"
            size="sm"
            onClick={goBack}
            disabled={isFirst}
            aria-label="Atrás"
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Atrás
          </Button>
        )}

        {showStepNavigation && (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={goPrev}
              disabled={isFirst}
              aria-label="Anterior"
            >
              <ChevronLeft className="h-4 w-4 mr-1" />
              Anterior
            </Button>

            <Button
              variant="outline"
              size="sm"
              onClick={goNext}
              disabled={isLast}
              aria-label="Siguiente"
            >
              Siguiente
              <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          </>
        )}

        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={restart}
            aria-label="Reiniciar"
          >
            <RotateCcw className="h-4 w-4 mr-1" />
            Reiniciar
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={handleExit}
            aria-label="Salir"
          >
            <LogOut className="h-4 w-4 mr-1" />
            Salir
          </Button>
        </div>
      </div>
    </div>
  );
}
